import React from 'react';
import classNames from 'classnames';
import { ErrorMessage, useFormikContext } from 'formik';

import { formStyles } from '../../../lib/constants/SiteVariables';

export default function EmailErrorComponent({
  fieldId,
  hasFieldError,
  onSuggestionClick,
}) {
  const { errors } = useFormikContext();
  const error = errors[fieldId];

  if (error?.suggestion) {
    return (
      <div
        className={classNames(
          'sm:h-5',
          formStyles.validation,
          hasFieldError ? 'my-0.5 h-4' : 'h-0'
        )}
      >
        <span>{error.message}, did you mean </span>
        {onSuggestionClick ? (
          <button
            type="button"
            onClick={() => onSuggestionClick(error.suggestion)}
            className="text-primary-blue hover:text-primary-blue-hover underline cursor-pointer"
          >
            {error.suggestion}
          </button>
        ) : (
          <span className="text-primary-blue">{error.suggestion}</span>
        )}
        <span>?</span>
      </div>
    );
  }

  return (
    <ErrorMessage
      name={fieldId}
      component="div"
      className={classNames(
        'sm:h-5',
        formStyles.validation,
        hasFieldError ? 'my-0.5 h-4' : 'h-0'
      )}
    />
  );
}
